import { useGetActiveTab } from '@/utilities/useGetActiveTab';
import { useNavigate } from 'react-router-dom';
import { Pagination } from 'shared-components';
import { ITab } from 'api-paths-cas';

interface IProps {
  showRangeSelector: boolean;

  defaultTab: string;
  queryKey: string;

  tabs: ITab[];

  /**
   * @param onNewPage Callback when a new page is selected.
   * @deprecated Use qsp values instead; kept for cas sheild backward compatibility with older table component.
   */
  onNewPage?: (page: string) => void;
}

const PAGE_SIZE = 40;

export function DashboardPagination(props: IProps) {
  const { showRangeSelector, queryKey, defaultTab, tabs, onNewPage } = props;

  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const activeTab = useGetActiveTab(defaultTab, queryKey);

  const countPerTab = tabs?.find(tab => tab.id === activeTab)?.count || 0;
  const maxPage = Math.ceil(countPerTab / PAGE_SIZE) || 1;
  const selectedPage = Number.parseInt(params.get('page') || '1', 10);

  const setNewPage = (page: number) => {
    const freshParams = new URLSearchParams(window.location.search);
    freshParams.set('page', page.toString());
    navigate({ search: freshParams.toString() });
    try {
      onNewPage?.(page.toString());
    } catch (error) {
      // If callback fails, continue gracefully
      console.warn('Page change callback failed:', error);
    }
  };

  return (
    <Pagination
      showRangeSelector={showRangeSelector}
      selectedPage={selectedPage}
      maxPage={maxPage}
      pageSize={PAGE_SIZE}
      onlyPageNumber={true}
      displaySelectedPage={setNewPage}
      disabled={false}
    />
  );
}
